import { signalStore, withState } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';

import { withSelectedEntity } from '../../../shared/store/selected-entity.feature';
import { Module } from '../../models/module.model';
import { avecMéthodesModules } from './module.methods';
import { initialState, ModuleState } from './module.state';

export const ModuleStore = signalStore(
  { providedIn: 'root' },
  withEntities<Module>(),
  withState<ModuleState>(initialState),
  withSelectedEntity(),
  avecMéthodesModules(),
);
